import { render, staticRenderFns } from "./AffiliateLinkNotification.vue?vue&type=template&id=d01a5bb6&"
import script from "./AffiliateLinkNotification.vue?vue&type=script&lang=js&"
export * from "./AffiliateLinkNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports